import { Box, Typography, useTheme } from "@mui/joy";
import React from "react";
import { Util } from "./Helpers/Util";

export default function Header() {
	const theme = useTheme();
	const [first, setFirst] = React.useState("");
	const [last, setLast] = React.useState("");
	React.useEffect(() => {
		getUserInfo();
	}, []);

	const getUserInfo = () => {
		fetch("/User/GetPersonInfo", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({}),
		})
			.then((x) => x.json())
			.then((y) => {
				setFirst(y.first_name);
				setLast(y.last_name);
				Util.CurrentRole = y.role;
			});
	};

	let fullName = first;
	if (!Util.isNullOrEmpty(last)) {
		fullName = fullName + " " + last.substring(0, 1) + ".";
	}

	return (
		<Box
			sx={{
				minHeight: "40px",
				mb: 1,
				px: 1,
				py: 0.75,
				backgroundColor: "background.surface",
				borderRadius: 0,
				border: `1px solid ${theme.vars.palette.divider}`,
				boxShadow: "sm",
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-end",
			}}>
			<Typography level="title-md" sx={{ color: "text.secondary" }}>
				Welcome, {fullName}
			</Typography>
		</Box>
	);
}
